import { Backbone } from "extensions/backbone";

import { ParameterizedCollection } from "common/collections/parameterizedCollection";

const State = Backbone.Model.extend({
    defaults: () => ({
        count: 0,
        limit: 100,
        page: 1,
        next: void 0
    })
});

export const StatefulCollection = ParameterizedCollection.extend({
    constructor: function constructor() {
        ParameterizedCollection.apply(this, arguments);
        
        this.state = new State();
        this.listenTo(this.state, "change", function(state) {
            this.trigger("change:state", this, state.toJSON());
        });
    },
    
    resetState() {
        this.state.clear().set(this.state.defaults());
    },
    
    parseState(resp) {
        const new_state = {
            count: resp.count,
            limit: Number.isFinite(resp.limit) ? resp.limit : this.state.defaults().limit,
            page: Number.isFinite(resp.page) ? resp.page : this.state.defaults().page
        };
        
        return {
            ...new_state,
            next: typeof resp.next === "boolean" ? resp.next : (new_state.page * new_state.limit > new_state.count ? new_state.count : new_state.page * new_state.limit) < new_state.count
        };
    },
    
    parseRecords(resp) {
        return resp?.results || resp;
    },
    
    parse(response, options) {
        const newState = this.parseState(response);
        if (newState) {
            this.setState(newState);
        }
        
        return this.parseRecords(response, options);
    },
    
    getState(item) {
        if (item) {
            return this.state.get(item);
        }
    
        return this.state.toJSON();
    },
    
    setState(newState, options) {
        this.state.set(newState);
    },
    
    getAllParameters() {
        return {
            limit: this.getState("limit"),
            page: this.getState("page"),
            ...this.queryParams
        };
    }
});
